<template>
  <nav
    id="header"
    :aria-label="$t('wegow.arias.topNavbar.navbar')"
    :class="{
      'header-opacity': scrolledHeader,
      fadeOut: !show,
      fadeIn: show,
      disNone: disNone
    }"
    class="animate__animated animated-header"
  >
    <div
      class="flex m-auto max-width-navbar items-center w-full"
      :class="isTicketOffice ? 'justify-start' : ' justify-around'"
    >
      <div
        v-if="windowWidth >= 930 || (windowWidth < 930 && onlyLogo)"
        class=""
        :class="isTicketOffice ? 'flex items-center' : 'header-icon'"
      >
        <router-link
          v-if="!isTicketOffice"
          :to="{ name: 'home' }"
        >
          <img
            :src="require('@/assets/images/ic-wegow-topaz.svg')"
            class="logo-wegow"
            alt="Conciertos Wegow"
            :class="'default-logo'"
          />
        </router-link>
        <a
          v-else
          :href="`/${getRegion}/taquilla/${eventSlug}`"          
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="require('@/assets/images/bracelit-logo.png')"
            class="logo-wegow"
            alt="Bracelit"
            :class="'ticket-logo'"
          />
        </a>
        <span v-if="isTicketOffice" class="ml-8 text-l">
          {{ $t("general.header.ticketOffice") }}
        </span>
      </div>
      <!-- TODO: v-if="
        v-on-clickaway="clickAway"-->
      <div
        v-if="!onlyLogo && (showSearch || isAuth) && windowWidth >= 930"
        class="ml-4 w-1/3"
      >
        <search-input
          id-input="top-search-input"
          :top-navbar="true"
          :recomendations="true"
        />
      </div>
      <div
        v-if="!onlyLogo && windowWidth >= 930"
        class="container-right navbar-options flex gap-x-[58px] items-center"
      >
        <a
          href="https://boxify.es/users/6314/stores/315?locale=es"
          target="_blank"
          rel="noopener noreferrer"
          class="title-option"
        >
          {{ $t("general.header.shop") }}
        </a>

        <router-link
          :target="isMagazine.name === 'MagazineMainPage' ? '_self' : '_blank'"
          class="text-gold news-link"
          :to="{
            name: 'MagazineMainPage',
            params: {
              region: getRegion
            }
          }"
          @click="sendGa('magazine')"
        >
          {{ $t("general.header.news") }}
        </router-link>

        <div v-if="isAuth" class="title-option" @click="openModal(CALENDAR)">
          {{ $t("general.header.calendar") }}
        </div>

        <router-link
          :to="{
            name: 'WegowLiveMain',
            params: {
              region: getRegion
            }
          }"
        >
          {{ $t("general.header.wegowlive") }}
        </router-link>
        <router-link
          v-if="isAuth && getRegion !== 'mx'"
          :to="{
            name: 'MyWeswapPage',
            params: {
              region: getRegion
            }
          }"
          class="title-option"
        >
          {{ $t("general.header.weswap") }}
        </router-link>
        <a
          v-else-if="getRegion !== 'mx'"
          href="https://www.wegow.com/landing/weswap/"
          _blank
        >
          {{ $t("general.header.weswap") }}
        </a>
        <wegow-button
          v-if="!isAuth"
          id="header-login-button"
          color="topaz"
          size="xs"
          type="button"
          :text="$t('general.header.login')"
          @click="
            openModal(SIGN_IN);
            sendGa('sign-in');
          "
        />
        <div v-if="isAuth" class="flex items-center gap-[28px] ml-[50px]">
          <img
            :src="require('@/assets/images/ic-comment.svg')"
            class="lazyload space-x-6 cursor-pointer"
            width="20"
            height="20"
            alt="chat"
            @click="router.push({ name: 'ChatPage' })"
          />

          <div>
            <img
              :src="getImageUrl(userDetail)"
              class="lazyload user-profile title-option"
              alt="userProfile"
              @error="
                $event.target.src = require('@/assets/images/placeholder-user.svg')
              "
              @click="changeSection('user')"
            />
            <div
              v-if="showTypeOptions === 'user'"
              ref="dropdownRef"
              class="profile-options flex flex-col pl-4 pr-3 pb-7 pt-4 gap-y-[20px]"
            >
              <profile-options />
            </div>
          </div>
          <img
            :src="
              newNotificatoins
                ? require('@/assets/images/ic-new-notification.svg')
                : require('@/assets/images/ic-notification.svg')
            "
            class="lazyload cursor-pointer"
            :class="newNotificatoins ? 'mb-2' : ''"
            alt="notifications"
            width="18"
            height="20"
            @click="changeSection('notifications')"
          />
          <!-- Complete with chat and click outside -->
          <!-- <header-chat
          v-if="showTypeOptions === 'notifications'"
          class="header-chat-box"
        /> -->
          <div
            v-if="showTypeOptions === 'notifications'"
            ref="dropdownRef"
            class="notifications-dropdown"
          >
            <header-notification />
          </div>
        </div>
      </div>
      <div
        v-else-if="!onlyLogo && windowWidth < 930"
        class="w-full flex justify-between px-6"
      >
        <div class="flex">
          <button
            aria-label="Menu"
            aria-haspopup="true"
            aria-expanded="false"
            type="button"
            class="btn btn-link"
            @click="showDropdown('options')"
          >
            <img
              :src="require('@/assets/images/ic-menu.png')"
              alt="menu icon"
              style="height: 20px; width: 20px;"
            />
          </button>

          <router-link :to="{ name: 'home' }"
            ><img
              :src="require('@/assets/images/ic-wegow-topaz.png')"
              class="logo-wegow ml-6"
              alt="Conciertos Wegow"
          /></router-link>
        </div>
        <div class="flex">
          <img
            :src="require('@/assets/images/ic-search.svg')"
            class="cursor-pointer ml-6"
            alt="search"
            heigth="42"
            width="24"
            @click="showDropdown('search')"
          />
          <img
            :src="getImageUrl(userDetail)"
            class="cursor-pointer ml-6"
            :class="isAuth ? 'rounded-full w-[42px] h-[42px]' : ''"
            alt="user"
            heigth="42"
            :width="isAuth ? '42' : '24'"
            @click="showDropdown('profile')"
          />
        </div>
      </div>
      <div
        v-if="!onlyLogo && dropdown === 'search'"
        class="search-navbar-dropdown absolute"
      >
        <search-input :recomendations="true" />
      </div>
      <div
        v-if="!onlyLogo && dropdown === 'options'"
        ref="dropdownRef"
        class="mobile-options-dropdown flex flex-col absolute top-0 left-0"
      >
        <a
          href="https://boxify.es/users/6314/stores/315?locale=es"
          target="_blank"
          rel="noopener noreferrer"
          class="title-option flex items-center"
        >
          {{ $t("general.header.shop") }}
        </a>
        <div v-if="isMagazine.name === 'MagazineMainPage'">
          <div
            class="title-option flex items-center news-link"
            @click="changeSectionDropdown('news')"
          >
            {{ $t("general.header.news") }}
            <img
              :src="
                showTypeOptionsDropdown === 'news'
                  ? require('@/assets/images/ic-dropdown-close.svg')
                  : require('@/assets/images/ic-dropdown.svg')
              "
              class="lazyload ml-auto h-2"
              alt="icon dropdown"
            />
          </div>
          <div v-if="showTypeOptionsDropdown === 'news'">
            <magazine-options
              :is-dropdown="true"
              type-section="news"
              @close-menu="closeMenu($event)"
            />
          </div>
        </div>

        <router-link
          v-else
          :to="{ name: 'MagazineMainPage' }"
          target="_blank"
          class="text-gold flex items-center news-link"
          @click="sendGa('magazine')"
        >
          {{ $t("general.header.news") }}
        </router-link>
        <div
          v-if="isAuth"
          class="title-option flex items-center"
          @click="openModal(CALENDAR)"
        >
          {{ $t("general.header.calendar") }}
        </div>
        <div
          class="title-option flex items-center"
          @click="changeSectionDropdown('concerts')"
        >
          {{ $t("general.header.concerts") }}
          <img
            :src="
              showTypeOptionsDropdown === 'concerts'
                ? require('@/assets/images/ic-dropdown-close.svg')
                : require('@/assets/images/ic-dropdown.svg')
            "
            class="lazyload ml-auto h-2"
            alt="icon dropdown"
          />
        </div>
        <div v-if="showTypeOptionsDropdown === 'concerts'" ref="dropdownRef">
          <navbar-dropdown :is-dropdown="true" type-section="concerts" />
        </div>
        <div
          class="title-option flex items-center"
          @click="changeSectionDropdown('festivals')"
        >
          {{ $t("general.header.festivals") }}
          <img
            :src="
              showTypeOptionsDropdown === 'festivals'
                ? require('@/assets/images/ic-dropdown-close.svg')
                : require('@/assets/images/ic-dropdown.svg')
            "
            class="lazyload ml-auto h-2"
            alt="icon dropdown"
          />
        </div>
        <div v-if="showTypeOptionsDropdown === 'festivals'" ref="dropdownRef">
          <navbar-dropdown :is-dropdown="true" type-section="festivals" />
        </div>
        <div
          class="title-option flex items-center"
          @click="changeSectionDropdown('ciclos')"
        >
          {{ $t("general.header.ciclos") }}
          <img
            :src="
              showTypeOptionsDropdown === 'ciclos'
                ? require('@/assets/images/ic-dropdown-close.svg')
                : require('@/assets/images/ic-dropdown.svg')
            "
            class="lazyload ml-auto h-2"
            alt="icon dropdown"
          />
        </div>
        <div v-if="showTypeOptionsDropdown === 'ciclos'" ref="dropdownRef">
          <navbar-dropdown :is-dropdown="true" type-section="ciclos" />
        </div>
        <div
          class="title-option flex items-center"
          @click="changeSectionDropdown('artists')"
        >
          {{ $t("general.header.artists") }}
          <img
            :src="
              showTypeOptionsDropdown === 'artists'
                ? require('@/assets/images/ic-dropdown-close.svg')
                : require('@/assets/images/ic-dropdown.svg')
            "
            class="lazyload ml-auto h-2"
            alt="icon dropdown"
          />
        </div>
        <div v-if="showTypeOptionsDropdown === 'artists'" ref="dropdownRef">
          <navbar-dropdown
            :is-dropdown="true"
            type-section="artists"
            :show-cities="false"
          />
        </div>
        <div
          class="title-option flex items-center"
          @click="changeSectionDropdown('venues')"
        >
          {{ $t("general.header.venues") }}
          <img
            :src="
              showTypeOptionsDropdown === 'venues'
                ? require('@/assets/images/ic-dropdown-close.svg')
                : require('@/assets/images/ic-dropdown.svg')
            "
            class="lazyload ml-auto h-2"
            alt="icon dropdown"
          />
        </div>
        <div v-if="showTypeOptionsDropdown === 'venues'" ref="dropdownRef">
          <navbar-dropdown
            :is-dropdown="true"
            type-section="venues"
            :show-genres="false"
          />
        </div>
        <router-link :to="{ name: 'WegowLiveMain' }">WegowLive</router-link>
        <router-link
          v-if="isAuth"
          :to="{
            name: 'MyWeswapPage',
            params: {
              region: getRegion
            }
          }"
        >
          WeSwap
        </router-link>
      </div>
      <div
        v-if="!onlyLogo && dropdown === 'profile' && isAuth"
        ref="dropdownRef"
        class="mobile-profile-dropdown flex flex-col absolute top-0 right-0"
      >
        <profile-options :mobile="true" />
      </div>
    </div>
  </nav>
  <magazine-categories v-if="isMagazine.name === 'MagazineMainPage'" />
  <general-options v-else-if="showSubNabvar" />
</template>

<script setup>
import { useUser } from "@/composables/useUser";
import { useNotification } from "@/composables/useNotification";
import { useRoute, useRouter } from "vue-router";
import { ref, computed, onBeforeMount, onMounted, watch } from "vue";
import { VueCookieNext } from "vue-cookie-next";
import SearchInput from "@/components/general/forms/complex-forms/SearchInput";
import WegowButton from "@/components/general/forms/WegowButton";
import MagazineOptions from "@/components/general/ui/navbar/MagazineOptions";
import NavbarDropdown from "@/components/general/ui/navbar/NavbarDropdown";
import GeneralOptions from "@/components/general/ui/navbar/GeneralOptions";
import ProfileOptions from "@/components/general/ui/navbar/ProfileOptions";
import HeaderNotification from "@/components/general/ui/navbar/HeaderNotification";
import MagazineCategories from "@/components/magazine/MagazineCategories";
import { useEvent } from "@/composables/useEvent";

import { useModalHandler } from "@/plugins/useModalHandler";
import useDetectOutsideClick from "@/plugins/useDetectOutsideClick";

const $cookie = VueCookieNext;
const router = useRouter();
const { details: event } = useEvent();
const eventSlug = computed(() => event.value?.slug || "");

const { SIGN_IN, CALENDAR, openModal } = useModalHandler();

const { userDetail, isAuth } = useUser();
const {
  notifications,
  getNotifications,
  updateNotification,
  readAllNotification
} = useNotification();

defineProps({
  showSearch: {
    type: Boolean,
    default: true
  },
  onlyLogo: {
    type: Boolean,
    default: false
  },
  showSubNabvar: {
    type: Boolean,
    default: true
  },
  isTicketOffice: {
    type: Boolean,
    default: false
  }
});

const dropdownRef = ref();

const openChat = ref(false);
const scrolledHeader = ref(false);
const windowWidth = ref(0);
const lastScroll = ref(0);
const show = ref(true);
const disNone = ref(false);
const route = useRoute();
const showTypeOptions = ref("");
const opening = ref("");
const dropdown = ref("");
const showTypeOptionsDropdown = ref("");
const showCategories = ref(false);

const getRegion = computed(() => {
  return route.params.region || userDetail.value.region || "es";
});

const newNotificatoins = computed(() => {
  return (
    isAuth.value &&
    notifications.value?.find(notification => notification.status === "unread")
  );
});

const closeMenu = $event => {
  if ($event) {
    dropdown.value = "";
  }
};

const getImageUrl = element => {
  if (element?.thumbnails?.s_sq) {
    return element.thumbnails.s_sq;
  } else if (element?.image_url) {
    return element.image_url;
  } else if (!isAuth.value) {
    return require("@/assets/images/ic-user.svg");
  } else {
    return require("@/assets/images/placeholder-user.svg");
  }
};

const changeSection = async section => {
  if (showTypeOptions.value === section) {
    showTypeOptions.value = "";
  } else {
    showTypeOptions.value = section;
    opening.value = section;
    sendGa(section);
  }

  if (section === "notifications" && newNotificatoins.value) {
    await readAllNotification({ status: "read" });
    // notifications.value.forEach(async notification => {
    //   if (notification.status === "unread") {
    //     debugger;
    //     await updateNotification({ id: notification.id, status: "read" });
    //   }
    // });
  }
};

const showDropdown = section => {
  if (section === "profile" && !isAuth.value) {
    openModal(SIGN_IN);
  } else if (dropdown.value === section) {
    dropdown.value = "";
  } else {
    dropdown.value = section;
    opening.value = section;
    sendGa(section);
  }
};

const changeSectionDropdown = section => {
  if (showTypeOptionsDropdown.value === section) {
    showTypeOptionsDropdown.value = "";
  } else {
    showTypeOptionsDropdown.value = section;
    sendGa(section);
  }
};

useDetectOutsideClick(dropdownRef, () => {
  if (!opening.value) {
    showTypeOptions.value = "";
  } else {
    opening.value = null;
  }
});

const isMagazine = computed(() => {
  if (route.path.includes("/magazine")) {
    return { name: "MagazineMainPage" };
  } else {
    return { name: "home" };
  }
});

const closeChat = () => {
  openChat.value = false;
};
const handleScroll = () => {
  scrolledHeader.value = false;
  show.value = true;
  var currentScroll = window.scrollY;
  if (currentScroll > lastScroll.value && currentScroll > 72) {
    show.value = false;
    setTimeout(() => {
      disNone.value = true;
    }, 1000);
  } else if (currentScroll < lastScroll.value && currentScroll > 72) {
    scrolledHeader.value = true;
    show.value = true;
    setTimeout(() => {
      disNone.value = false;
    }, 1000);
  } else if (currentScroll < lastScroll.value && currentScroll < 72) {
    scrolledHeader.value = false;
    show.value = true;
    setTimeout(() => {
      disNone.value = false;
    }, 1000);
  }
  // if (show.value) this.$root.$emit("showHeader", true);
  // else this.$root.$emit("showHeader", false);
  lastScroll.value = currentScroll;
};
const logout = async () => {
  // await this.$store.dispatch("user/clean");
  // await this.$store.dispatch("initial/clean");
  window.location.reload();
};
const sendGa = label => {
  // if (this.$gtag && typeof this.$gtag.event === "function")
  //   this.$gtag.event("click", {
  //     event_category: label
  //   });
};
const updateScreen = () => {
  windowWidth.value = window.innerWidth;
};

onBeforeMount(async () => {
  if (isAuth.value && notifications.value?.length === 0) {
    setTimeout(async () => {
      await getNotifications();
    }, 100);
  }
  window.removeEventListener("resize", updateScreen);
});
onMounted(() => {
  window.addEventListener("resize", updateScreen);
});

watch(
  windowWidth,
  newWidth => {
    updateScreen();
  },
  { immediate: true }
);

handleScroll();
</script>

<style lang="scss">
header.animated-header {
  animation-duration: 0.5s;
  animation-delay: 0s;
}

header.header-opacity {
  // background-color: $backgroundBlack;
  background-color: $backgroundGrey;
}

.ticket-logo {
  height: 40px;
  margin-top: 2px;
}

.default-logo {
  width: 40px;
  height: 40px;
  margin-top: 2px;
}

#header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-right: 15px;
  // background-color: $backgroundGrey;
  .container-right {
    a {
      margin: 0;
    }
    .icon-chats-unread,
    .icon-notifications-unread {
      position: relative;
      &::before {
        content: " ";
        position: absolute;
        right: -1px;
        top: -4px;
        width: 8px;
        height: 8px;
        border-radius: 100%;
        background-color: $red;
      }
    }
  }
  .max-width-navbar {
    max-width: 1800px;
  }
  .user-profile {
    object-fit: cover;
    border-radius: 100%;
    height: 43px;
    width: 43px;
  }
  .search-navbar-dropdown {
    width: 100%;
    height: auto;
    padding: 12px;
    padding-top: 140px;
    background: #000214;
    z-index: -1;
  }
  .mobile-options-dropdown {
    overflow-y: auto;
    background-color: $backgroundBlack;
    height: calc(100vh - $headerHeight);
    margin-top: $headerHeight;
    min-width: 80%;

    .text-gold {
      color: #ffce00;
      font-weight: 250;
      font-size: 15px;
      line-height: 22px;
    }
    & > a,
    & div.title-option {
      min-height: 39px;
      padding-left: 24px;
      padding-right: 31px;
    }
  }
  .mobile-profile-dropdown {
    overflow-y: auto;
    background-color: $backgroundBlack;
    height: calc(100vh - $headerHeight);
    margin-top: $headerHeight;
    min-width: 80%;
    & > a,
    & > span {
      margin: 0px;
      min-height: 39px;
      padding-left: 24px;
      padding-right: 31px;
      display: flex;
      align-items: center;
    }
  }
}
</style>

<style lang="scss">
#header {
  .news-link {
    font-weight: 100;
  }
}
#header a:not(.news-link),
#header span.button {
  text-decoration: none;
  color: $white;
}
.header-icon {
  a {
    display: contents;
  }
}
.navbar-options {
  & > a,
  .title-option {
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    &.selected {
      color: $topaz;
    }
  }
  .text-gold {
    color: #ffce00;
    font-weight: 250;
    font-size: 15px;
    line-height: 22px;
  }
  & > button {
    font-size: 15px !important;
    line-height: 22px !important;
  }
  .profile-options {
    position: absolute;
    background-color: $backgroundBlack;
    margin-top: 23px;
    right: 0px;
    width: 300px;
    a {
      margin-left: 0px;
    }
  }
  .comment-icon {
    height: 20px;
    width: 20px;
  }
  .notifications-dropdown {
    margin-top: 64px !important;
    top: 0;
    position: absolute;
    background-color: $backgroundGrey;
    max-height: 438px;
    width: 454px;
    right: 0;
    box-shadow: 0px 4px 9px 5px rgba(0, 0, 0, 0.25);
    overflow-y: auto;
  }
}
input {
  color: $white;
}
</style>
